const environment = env => {
  let url
  switch (env) {
    case 'local':
      url = 'http://localhost:4000/dev/'
      break
    case 'alpha':
      url = 'https://yywnoenrhc.execute-api.us-east-1.amazonaws.com/alpha/'
      break
    case 'dev':
      url = 'https://2f42gimho3.execute-api.us-east-1.amazonaws.com/dev/'
      break
    case 'staging':
      url = 'https://yer67p96a7.execute-api.us-east-1.amazonaws.com/staging/'
      break
    case 'prod':
      url = 'https://e0ecvb1ih3.execute-api.us-east-1.amazonaws.com/prod/'
      break
    default:
      throw new Error(`Invalid environment: ${env}`)
  }

  // Build the environment object
  return {
    apis: {
      public_data: {
        uri: 'https://my-asset-map-data.s3.amazonaws.com/public_data/',
      },
      apiDatabase: {
        uri: url,
      },
    },
    aws: {
      region: process.env.AWS_REGION,
      s3Bucket: process.env.AWS_S3_BUCKET_NAME,
      userPoolId: process.env.AWS_USER_POOL_ID,
      identityPoolId: process.env.AWS_IDENTITY_POOL_ID,
      userPoolWebClientId: process.env.AWS_APP_CLIENT_ID,
      awsApiAmplifyUrl: process.env.AWS_API_AMPLIFY_URL,
      awsApiAmplifyUrl2: process.env.AWS_API_AMPLIFY_URL2,
    },
    keys: {
      google: process.env.GOOGLE_API_KEY,
      agGrid: process.env.AG_GRID_KEY,
      // Analytics Providers (Optional)
      posthog: process.env.POSTHOG_KEY,
      logrocket: process.env.LOGROCKET_ID,
      clarity: process.env.CLARITY_PROJECT_ID,
      gtm: process.env.GOOGLE_TAG_MANAGER_ID,
      sentry: process.env.SENTRY_DSN,
      released: {
        channelId:
          process.env.RELEASED_CHANNEL_ID ||
          'b825d3e4-5ca8-41b8-92db-99f1055fd4e1',
      },
    },
    build: process.env.NODE_ENV,
    env,
    isProd: env === 'prod',
    isStaging: env === 'staging',
    isDev: !['staging', 'prod'].includes(env),
    isLocal:
      (typeof window !== 'undefined' &&
        (window.location.hostname === 'localhost' ||
          window.location.hostname === '127.0.0.1')) ||
      env === 'local',
  }
}

export default environment
